import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PwcIconsLibrary, piCheck, piClear } from '@pwc-bei/icons';
import { EAccessPlanVariable } from 'src/app/enum/access-plan-variable';
import { RoutePath } from 'src/app/enums/route-path.enum';
import { BasePage } from 'src/app/pages/base-page/base-page';
import { AuthenticationUtilsService } from 'src/app/services/authentication-utils.service';

@Component({
    selector: 'app-upgrade-plan-form',
    templateUrl: './upgrade-plan-form.component.html',
    styleUrls: ['./upgrade-plan-form.component.scss'],
    standalone: false
})
export class UpgradePlanFormComponent extends BasePage implements OnInit {
  selectedPlan: string = null;

  constructor(
    private iconsLibrary: PwcIconsLibrary,
    private authenticationUtilsService: AuthenticationUtilsService,
    private router: Router,
  ) {
    super();
    this.iconsLibrary.registerIcons([piClear, piCheck]);
  }
  ngOnInit(): void {}

  get isPlusEnabled(): boolean {
    return this.authenticationUtilsService.getAccessPlan(
      EAccessPlanVariable.IS_USER_PLUS,
    );
  }

  onPlanChoose(): void {
    console.log(this.selectedPlan);
    if (this.selectedPlan) {
      this.router.navigate([RoutePath.BANDI, RoutePath.HELPDESK], {
        queryParams: { selectedPlan: this.selectedPlan },
      });
    }
  }

  goBack(): void {
    this.router.navigate([RoutePath.BANDI, RoutePath.BASE]);
  }

  selectUpgradePlan(input: string): void {
    this.selectedPlan = input;
  }
}
